import CompatModule from './AvoidSoftInputModuleCompat';
export default CompatModule;
//# sourceMappingURL=AvoidSoftInputModule.web.js.map